{
  "status": {
    "IN_PROGRESS": "قيد المطابقة",
    "COMPLETED": "مكتمل"
  },
  "periodRange": "{{from}} – {{to}}",
  "fields": {
    "number": "الرقم",
    "account": "الحساب",
    "reference": "مرجع البنك",
    "period": "الفترة",
    "periodStart": "من تاريخ",
    "periodEnd": "إلى تاريخ",
    "opening": "الرصيد الافتتاحي",
    "closing": "الرصيد الختامي",
    "matched": "المطابَق",
    "status": "الحالة",
    "date": "التاريخ",
    "description": "البيان",
    "amount": "المبلغ",
    "moneyIn": "إيداع",
    "moneyOut": "سحب"
  },
  "list": {
    "title": "التسوية البنكية",
    "subtitle": "كشوف الحسابات البنكية مطابَقة مع الدفاتر، حسابًا حسابًا.",
    "new": "كشف جديد",
    "searchLabel": "البحث في الكشوف",
    "searchPlaceholder": "ابحث بالرقم أو مرجع البنك…",
    "accountFilter": "الحساب",
    "allAccounts": "كل الحسابات",
    "statusFilter": "الحالة",
    "allStatuses": "كل الحالات",
    "matchedOf": "{{matched}} من {{lines}}",
    "emptyTitle": "لا توجد كشوف بنكية بعد.",
    "emptyBody": "أدخل كشف حساب البنك لمطابقة الحساب مع الدفاتر.",
    "stats": {
      "label": "أرقام الكشوف",
      "inProgress": "قيد المطابقة",
      "matchedDetail": "طوبق {{matched}} من {{lines}} سطرًا",
      "matchedShare": "طوبق {{percent}}٪ من أسطرها",
      "toMatch": "أسطر بانتظار المطابقة",
      "toMatchDetail": "وارد {{moneyIn}} · صادر {{moneyOut}}",
      "completed": "المكتملة",
      "reconciledThrough": "مسوّاة حتى {{date}}",
      "noneCompleted": "لا كشوف مكتملة بعد"
    }
  },
  "new": {
    "title": "كشف حساب بنكي جديد",
    "subtitle": "أدخل فترة الكشف وأرصدته كما وردت من البنك، ثم استورد حركاته أو اكتبها.",
    "sections": {
      "statement": "الكشف",
      "statementHint": "كما هي مطبوعة في كشف البنك.",
      "lines": "الحركات",
      "linesHint": "استورد ملف CSV من البنك أو اكتب الحركات، ويمكنك إضافة حركات لاحقًا أيضًا."
    },
    "chooseAccount": "اختر الحساب البنكي",
    "noAccounts": "لا يوجد حساب بنكي أو جهاز بطاقات أو محفظة بعد. اطلب من المسؤول إضافة واحد من المحاسبة › النقدية والبنوك.",
    "referenceHint": "رقم كشف البنك إن وُجد.",
    "openingHint": "يبدأ أول كشف للحساب بأي رصيد، وتبدأ الكشوف التالية بالرصيد الختامي للكشف السابق.",
    "save": "إنشاء الكشف",
    "created": "أُنشئ الكشف {{number}}",
    "closingOff": "الرصيد الافتتاحي مع الحركات لا يساوي هذا الرصيد.",
    "outOfBalance": "الكشف غير متوازن: الرصيد الافتتاحي مع الحركات يختلف عن الرصيد الختامي بمقدار {{difference}}. راجع الأرصدة أو الحركات.",
    "lineIssue": "السطر {{line}}: {{message}}",
    "blockers": {
      "syntax": "تعذّرت قراءة الملف: صحّحه أو اختر ملفًا آخر.",
      "overLimit": "يتسع الكشف لـ 2,000 سطر على الأكثر: قسّمه حسب الفترة.",
      "manual": "بعض الحركات المكتوبة ناقصة: أعطِ كل حركة تاريخًا داخل الفترة ومبلغًا واحدًا.",
      "noRows": "لا يحتوي الملف على حركات للاستيراد.",
      "errors_zero": "لا يوجد في الملف سطر به خطأ.",
      "errors_one": "في الملف سطر واحد به خطأ: صحّح إعدادات الأعمدة أو استبعده.",
      "errors_two": "في الملف سطران بهما أخطاء: صحّح إعدادات الأعمدة أو استبعدهما.",
      "errors_few": "في الملف {{count}} أسطر بها أخطاء: صحّح إعدادات الأعمدة أو استبعدها.",
      "errors_many": "في الملف {{count}} سطرًا بها أخطاء: صحّح إعدادات الأعمدة أو استبعدها.",
      "errors_other": "في الملف {{count}} سطر بها أخطاء: صحّح إعدادات الأعمدة أو استبعدها."
    }
  },
  "lines": {
    "source": "مصدر الحركات",
    "fromFile": "استيراد ملف CSV",
    "typed": "كتابة الحركات",
    "typedLabel": "حركات الكشف",
    "add": "إضافة سطر",
    "remove": "حذف السطر {{n}}",
    "actions": "إجراءات",
    "total": "الإجمالي",
    "enterHint": "الضغط على Enter في السطر الأخير يضيف سطرًا جديدًا.",
    "dateOf": "تاريخ السطر {{n}}",
    "descriptionOf": "بيان السطر {{n}}",
    "referenceOf": "مرجع السطر {{n}}",
    "moneyInOf": "الإيداع في السطر {{n}}",
    "moneyOutOf": "السحب في السطر {{n}}",
    "issues": {
      "date": "أدخل التاريخ.",
      "outsidePeriod": "التاريخ خارج فترة الكشف.",
      "amount": "أدخل مبلغ الإيداع أو السحب.",
      "both": "أدخل الإيداع أو السحب، لا كليهما."
    }
  },
  "csv": {
    "choose": "اختيار ملف CSV…",
    "chooseAnother": "اختيار ملف آخر…",
    "fileLabel": "ملف الكشف (CSV)",
    "hint": "ملف CSV المُصدَّر من البنك: سطر لكل حركة، وبحد أقصى {{max}} سطر.",
    "fileError": {
      "tooLarge": "حجم الملف أكبر من 5 ميغابايت، فهو ليس كشف حساب بنكي.",
      "unreadable": "تعذّرت قراءة الملف. حاول مرة أخرى."
    },
    "syntaxTitle": "الملف ليس بصيغة CSV صحيحة",
    "syntax": {
      "unterminatedQuote": "السطر {{line}}: حقل بين علامتي تنصيص لم يُغلق.",
      "strayQuote": "السطر {{line}}: علامة تنصيص داخل حقل غير منصَّص.",
      "textAfterQuote": "السطر {{line}}: يوجد نص بعد علامة التنصيص الختامية."
    },
    "settings": "إعدادات الملف",
    "delimiter": "الفاصل",
    "delimiters": {
      "comma": "فاصلة (,)",
      "semicolon": "فاصلة منقوطة (;)",
      "tab": "مسافة جدولة (Tab)"
    },
    "encoding": "الترميز",
    "encodingHint": "اختر العربية (Windows) إذا ظهر النص العربي رموزًا.",
    "encodings": {
      "utf-8": "يونيكود (UTF-8)",
      "windows-1256": "العربية (Windows-1256)"
    },
    "skipRows": "أسطر تُتجاوز في الأعلى",
    "skipRowsHint": "أسطر العنوان فوق عناوين الأعمدة.",
    "hasHeader": "السطر الأول يحمل أسماء الأعمدة",
    "dateColumn": "عمود التاريخ",
    "dateFormat": "صيغة التاريخ",
    "chooseColumn": "اختر عمودًا",
    "chooseFormat": "اختر الصيغة",
    "fits": "تُقرأ التواريخ بصيغة: {{formats}}",
    "fitsNone": "لا توجد صيغة تقرأ كل التواريخ: راجع عمود التاريخ.",
    "formats": {
      "dmy": "يوم/شهر/سنة (dd/mm/yyyy)",
      "mdy": "شهر/يوم/سنة (mm/dd/yyyy)",
      "ymd": "سنة-شهر-يوم (yyyy-mm-dd)"
    },
    "descriptionColumn": "عمود البيان",
    "referenceColumn": "عمود المرجع",
    "noColumn": "بدون",
    "column": "العمود {{n}}",
    "columnNamed": "العمود {{n}} · {{name}}",
    "layout": "المبالغ",
    "layouts": {
      "signed": "عمود مبلغ واحد (بإشارة)",
      "split": "عمودان منفصلان للمدين والدائن"
    },
    "amountColumn": "عمود المبلغ",
    "debitColumn": "عمود المدين",
    "creditColumn": "عمود الدائن",
    "sign": "اصطلاح الإشارة",
    "signs": {
      "signed": {
        "standard": "المبالغ الموجبة إيداعات (داخلة إلى الحساب)",
        "reversed": "المبالغ الموجبة سحوبات (خارجة من الحساب)"
      },
      "split": {
        "standard": "الدائن إيداع والمدين سحب (من منظور البنك)",
        "reversed": "المدين إيداع والدائن سحب"
      }
    },
    "summary": "الأسطر المقروءة: {{rows}} · الجاهزة للاستيراد: {{valid}}",
    "deposits": "الإيداعات",
    "withdrawals": "السحوبات",
    "previewLabel": "الأسطر المراد استيرادها",
    "fileLine": "السطر",
    "previewCapped": "يُعرض {{shown}} من أصل {{total}} (الأخطاء أولًا)، وتُستورد كل الأسطر الصحيحة.",
    "issues": {
      "date": {
        "missing": "لا يوجد تاريخ.",
        "invalid": "التاريخ لا يُقرأ بالصيغة المختارة.",
        "noFormat": "اختر صيغة التاريخ.",
        "outsidePeriod": "التاريخ خارج فترة الكشف."
      },
      "amount": {
        "missing": "لا يوجد مبلغ.",
        "zero": "المبلغ صفر.",
        "both": "عمودا المدين والدائن كلاهما معبّأ.",
        "invalid": "المبلغ ليس رقمًا.",
        "tooManyDecimals": "في المبلغ أكثر من 3 منازل عشرية.",
        "tooLarge": "المبلغ كبير جدًا."
      },
      "description": {
        "truncated": "اختُصر البيان إلى 250 حرفًا."
      },
      "reference": {
        "truncated": "اختُصر المرجع إلى 100 حرف."
      }
    },
    "loaded_zero": "{{name}}: لا أسطر",
    "loaded_one": "{{name}}: سطر واحد",
    "loaded_two": "{{name}}: سطران",
    "loaded_few": "{{name}}: {{count}} أسطر",
    "loaded_many": "{{name}}: {{count}} سطرًا",
    "loaded_other": "{{name}}: {{count}} سطر",
    "withErrors_zero": "لا أسطر بها أخطاء",
    "withErrors_one": "سطر واحد به خطأ",
    "withErrors_two": "سطران بهما أخطاء",
    "withErrors_few": "{{count}} أسطر بها أخطاء",
    "withErrors_many": "{{count}} سطرًا بها أخطاء",
    "withErrors_other": "{{count}} سطر بها أخطاء",
    "skipBad_zero": "استبعاد الأسطر التي بها أخطاء",
    "skipBad_one": "استبعاد السطر الذي به خطأ",
    "skipBad_two": "استبعاد السطرين اللذين بهما أخطاء",
    "skipBad_few": "استبعاد {{count}} أسطر بها أخطاء",
    "skipBad_many": "استبعاد {{count}} سطرًا بها أخطاء",
    "skipBad_other": "استبعاد {{count}} سطر بها أخطاء"
  },
  "balance": {
    "opening": "الافتتاحي",
    "closing": "الختامي",
    "difference": "الفرق",
    "balanced": "متوازن",
    "noLines": "لا توجد حركات بعد: يُتحقق من التوازن عند الإتمام.",
    "enterBalances": "أدخل الرصيدين الافتتاحي والختامي.",
    "lines_zero": "لا أسطر",
    "lines_one": "سطر واحد",
    "lines_two": "سطران",
    "lines_few": "{{count}} أسطر",
    "lines_many": "{{count}} سطرًا",
    "lines_other": "{{count}} سطر"
  },
  "page": {
    "autoMatch": "مطابقة تلقائية",
    "addLines": "إضافة حركات",
    "editHeader": "تعديل البيانات",
    "complete": "إتمام",
    "reopen": "إعادة فتح",
    "bankReference": "مرجع البنك {{reference}}",
    "tabs": "عرض الكشف",
    "tabReconcile": "المطابقة",
    "tabReport": "مذكرة التسوية",
    "tabAttachments": "المرفقات",
    "blockers": {
      "outOfBalance": "يتاح الإتمام عندما يتوازن الكشف: الرصيد الافتتاحي مع الحركات يختلف عن الختامي بمقدار {{difference}}.",
      "unmatched_zero": "يتاح الإتمام بعد مطابقة كل الأسطر.",
      "unmatched_one": "يتاح الإتمام بعد مطابقة كل الأسطر: بقي سطر واحد.",
      "unmatched_two": "يتاح الإتمام بعد مطابقة كل الأسطر: بقي سطران.",
      "unmatched_few": "يتاح الإتمام بعد مطابقة كل الأسطر: بقيت {{count}} أسطر.",
      "unmatched_many": "يتاح الإتمام بعد مطابقة كل الأسطر: بقي {{count}} سطرًا.",
      "unmatched_other": "يتاح الإتمام بعد مطابقة كل الأسطر: بقي {{count}} سطر."
    }
  },
  "summary": {
    "deposits": "الإيداعات",
    "withdrawals": "السحوبات",
    "statementDifference": "فرق الكشف"
  },
  "workspace": {
    "keys": "↑/↓ للتنقل · المسافة للتحديد · Enter للمطابقة · Esc لمسح التحديد",
    "statementLines": "حركات الكشف",
    "unmatchedOf": "{{unmatched}} من {{lines}} بانتظار المطابقة",
    "noLines": "لا توجد حركات في هذا الكشف بعد.",
    "noLinesBody": "أضفها من ملف البنك أو اكتبها.",
    "selected": "محدد",
    "match": "المطابقة",
    "actions": "إجراءات",
    "lineLabel": "السطر {{n}} · {{date}} · {{description}} · {{amount}}",
    "unmatched": "غير مطابَق",
    "unmatchLine": "إلغاء مطابقة السطر {{n}}",
    "adjustLine": "قيد تسوية للسطر {{n}}",
    "deleteLine": "حذف السطر {{n}}",
    "book": "قيود الدفاتر",
    "bookFor": "المرشحة للسطر {{n}}",
    "window": "نطاق التاريخ",
    "pickLine": "اختر سطرًا غير مطابَق",
    "pickLineBody": "تظهر هنا القيود المرشحة له، والمبالغ المطابقة أولًا.",
    "noCandidates": "لا توجد قيود في هذا النطاق.",
    "noCandidatesBody": "وسّع النطاق، أو سجّل قيد تسوية إن كانت الحركة لدى البنك وحده.",
    "entry": "القيد",
    "bookLabel": "القيد {{entry}} · {{date}} · {{amount}}",
    "exact": "مبلغ مطابق",
    "selection": "التحديد",
    "difference": "الفرق",
    "clear": "مسح",
    "matchAction": "مطابقة",
    "kind": {
      "MATCH": "مطابَق",
      "ADJUSTMENT": "قيد تسوية"
    },
    "windowDays_zero": "اليوم نفسه",
    "windowDays_one": "± يوم واحد",
    "windowDays_two": "± يومان",
    "windowDays_few": "± {{count}} أيام",
    "windowDays_many": "± {{count}} يومًا",
    "windowDays_other": "± {{count}} يوم",
    "selectedLines_zero": "الكشف: لا أسطر",
    "selectedLines_one": "الكشف: سطر واحد",
    "selectedLines_two": "الكشف: سطران",
    "selectedLines_few": "الكشف: {{count}} أسطر",
    "selectedLines_many": "الكشف: {{count}} سطرًا",
    "selectedLines_other": "الكشف: {{count}} سطر",
    "selectedBook_zero": "الدفاتر: لا قيود",
    "selectedBook_one": "الدفاتر: قيد واحد",
    "selectedBook_two": "الدفاتر: قيدان",
    "selectedBook_few": "الدفاتر: {{count}} قيود",
    "selectedBook_many": "الدفاتر: {{count}} قيدًا",
    "selectedBook_other": "الدفاتر: {{count}} قيد",
    "matched_zero": "لم يُطابَق أي سطر",
    "matched_one": "طوبق سطر واحد",
    "matched_two": "طوبق سطران",
    "matched_few": "طوبقت {{count}} أسطر",
    "matched_many": "طوبق {{count}} سطرًا",
    "matched_other": "طوبق {{count}} سطر"
  },
  "header": {
    "title": "تعديل {{number}}",
    "body": "لا يتغير الحساب أبدًا، ويجب أن تبقى الحركات داخل الفترة.",
    "save": "حفظ البيانات",
    "saved": "حُفظت بيانات الكشف",
    "conflictTitle": "عدّل شخص آخر هذا الكشف",
    "conflictBody": "أعد التحميل لترى تعديلاته، ثم أدخل تعديلاتك مجددًا.",
    "reload": "إعادة التحميل"
  },
  "addLines": {
    "title": "إضافة حركات إلى {{number}}",
    "body": "حركات مؤرخة من {{from}} إلى {{to}}.",
    "none": "لا توجد حركات لإضافتها.",
    "save_zero": "إضافة الحركات",
    "save_one": "إضافة سطر واحد",
    "save_two": "إضافة سطرين",
    "save_few": "إضافة {{count}} أسطر",
    "save_many": "إضافة {{count}} سطرًا",
    "save_other": "إضافة {{count}} سطر",
    "done_zero": "لم تُضف أي حركة",
    "done_one": "أُضيف سطر واحد",
    "done_two": "أُضيف سطران",
    "done_few": "أُضيفت {{count}} أسطر",
    "done_many": "أُضيف {{count}} سطرًا",
    "done_other": "أُضيف {{count}} سطر"
  },
  "adjust": {
    "title": "قيد تسوية للسطر {{n}}",
    "body": "لحركة لدى البنك وحده، مثل الرسوم البنكية أو الفوائد.",
    "account": "الحساب المقابل",
    "accountHint": "حساب مصروفات أو أصول، وليس حساب نقدية أو بنك أو حساب رقابة.",
    "chooseAccount": "اختر الحساب",
    "searchAccounts": "ابحث برمز الحساب أو اسمه…",
    "noAccounts": "لا يوجد حساب مطابق.",
    "noAccess": "لا يمكنك عرض الحسابات التي يُرحَّل إليها. اطلب صلاحية الاطلاع على دفتر الأستاذ.",
    "postsTitle": "سيُرحَّل قيد يومية",
    "postsIn": "بتاريخ {{date}}: إيداع {{amount}} في الحساب البنكي مقابل الحساب المختار، بمرجع {{number}}. يُطابَق القيد مع هذا السطر، وإلغاء المطابقة يعكسه.",
    "postsOut": "بتاريخ {{date}}: سحب {{amount}} من الحساب البنكي على الحساب المختار، بمرجع {{number}}. يُطابَق القيد مع هذا السطر، وإلغاء المطابقة يعكسه.",
    "save": "ترحيل ومطابقة",
    "done": "رُحّل قيد التسوية للسطر {{n}}"
  },
  "auto": {
    "title": "مطابقة تلقائية",
    "body": "تطابق كل سطر في الكشف مع القيد الوحيد الذي له المبلغ والاتجاه نفسهما ضمن النطاق، وتترك لك الأسطر التي لها أكثر من قيد محتمل.",
    "window": "نطاق التاريخ",
    "windowHint": "عدد الأيام التي قد يبعدها تاريخ القيد عن تاريخ البنك.",
    "run": "مطابقة تلقائية",
    "resultTitle": "انتهت المطابقة التلقائية",
    "result_zero": "طوبق {{matched}}، ولم يبقَ أي سطر غير مطابَق.",
    "result_one": "طوبق {{matched}}، وبقي سطر واحد غير مطابَق.",
    "result_two": "طوبق {{matched}}، وبقي سطران غير مطابَقين.",
    "result_few": "طوبق {{matched}}، وبقيت {{count}} أسطر غير مطابَقة.",
    "result_many": "طوبق {{matched}}، وبقي {{count}} سطرًا غير مطابَق.",
    "result_other": "طوبق {{matched}}، وبقي {{count}} سطر غير مطابَق."
  },
  "complete": {
    "title": "إتمام {{number}}؟",
    "body": "الكشف متوازن وكل أسطره مطابَقة. بعد الإتمام تُقفل حركاته ومطابقاته، ولا يعدّله إلا من يملك صلاحية إعادة فتح الكشوف.",
    "confirm": "إتمام الكشف",
    "done": "اكتمل الكشف {{number}}"
  },
  "reopen": {
    "title": "إعادة فتح {{number}}؟",
    "body": "لا يُعاد فتح إلا أحدث كشف للحساب، وتصبح حركاته ومطابقاته قابلة للتعديل من جديد.",
    "reason": "السبب",
    "confirm": "إعادة الفتح",
    "done": "أُعيد فتح الكشف {{number}}"
  },
  "unmatch": {
    "title": "إلغاء مطابقة السطر {{lines}}؟",
    "body_zero": "تعود أسطر الكشف ({{total}}) وقيودها في الدفاتر غير مطابَقة.",
    "body_one": "يعود سطر الكشف ({{total}}) وقيوده في الدفاتر غير مطابَقة.",
    "body_two": "يعود سطرا الكشف ({{total}}) وقيودهما في الدفاتر غير مطابَقة.",
    "body_few": "تعود {{count}} أسطر من الكشف ({{total}}) وقيودها في الدفاتر غير مطابَقة.",
    "body_many": "يعود {{count}} سطرًا من الكشف ({{total}}) وقيودها في الدفاتر غير مطابَقة.",
    "body_other": "يعود {{count}} سطر من الكشف ({{total}}) وقيودها في الدفاتر غير مطابَقة.",
    "adjustmentBody": "يُعكس قيد التسوية {{entry}} بتاريخه نفسه، ويعود السطر غير مطابَق.",
    "confirm": "إلغاء المطابقة",
    "done": "أُلغيت المطابقة"
  },
  "deleteLine": {
    "title": "حذف السطر {{n}}؟",
    "body": "يُحذف السطر من الكشف، ولا تُحذف إلا الأسطر غير المطابَقة.",
    "confirm": "حذف السطر",
    "done": "حُذف السطر {{n}}"
  },
  "report": {
    "title": "مذكرة التسوية البنكية",
    "subtitle": "{{account}} · {{number}} · في {{date}}",
    "print": "طباعة",
    "bookBalance": "الرصيد حسب الدفاتر في {{date}}",
    "lessDeposits": "يُطرح: إيداعات لم تظهر في الكشف بعد",
    "addPayments": "يُضاف: مدفوعات لم يصرفها البنك بعد",
    "addClearedAhead": "يُضاف: حركات صرفها البنك قبل قيدها في الدفاتر",
    "lessOpeningItems": "يُطرح: بنود افتتاحية لم تُسوَّ بعد",
    "adjustedBook": "رصيد الدفاتر المعدَّل",
    "closing": "الرصيد حسب كشف البنك",
    "difference": "الفرق",
    "reconciled": "الحساب مسوّى: رصيد الدفاتر المعدَّل يساوي رصيد البنك.",
    "notReconciled": "رصيد الدفاتر المعدَّل يختلف عن رصيد البنك: طابق الأسطر المتبقية أو سجّل قيود تسوية.",
    "startingDifference": "فرق البداية",
    "startingExplained": "بنود قُيّدت قبل {{date}}، تاريخ بدء التسوية، ولم يصرفها البنك بعد، وتخرج من الفرق كلما طوبقت.",
    "outstandingDeposits": "إيداعات لم تظهر في الكشف بعد",
    "outstandingPayments": "مدفوعات لم يصرفها البنك بعد",
    "clearedAhead": "حركات صرفها البنك قبل قيدها",
    "none": "لا شيء.",
    "total": "الإجمالي",
    "completedAt": "اكتمل في {{time}}.",
    "inProgress": "قيد المطابقة: تتغير الأرقام كلما طوبقت الأسطر."
  },
  "errors": {
    "STATEMENT_OUT_OF_BALANCE": "الرصيد الافتتاحي مع الحركات لا يساوي الرصيد الختامي. راجع الأرصدة والحركات.",
    "STATEMENT_COMPLETED": "هذا الكشف مكتمل؛ أعد فتحه قبل تعديله.",
    "MATCH_UNBALANCED": "أسطر الكشف والقيود المحددة لا تتساوى في المبلغ.",
    "UNMATCHED_LINES": "بعض أسطر الكشف غير مطابَقة بعد. طابقها، أو سجّل قيد تسوية للرسوم البنكية والفوائد.",
    "NOT_LATEST_STATEMENT": "لا يُعاد فتح إلا أحدث كشف للحساب.",
    "PERIOD_NOT_AFTER_PREVIOUS": "يجب أن تبدأ الفترة بعد انتهاء آخر كشف مكتمل.",
    "OPENING_BALANCE_MISMATCH": "يجب أن يساوي الرصيد الافتتاحي الرصيد الختامي للكشف السابق.",
    "MATCHED_BEFORE_START": "توجد قيود مطابَقة مؤرخة قبل بداية الفترة الجديدة؛ ألغِ مطابقتها أولًا.",
    "LINE_MATCHED": "ألغِ مطابقة السطر قبل حذفه.",
    "TOO_MANY_LINES": "يتسع الكشف لـ 2,000 سطر على الأكثر؛ قسّمه حسب الفترة."
  }
}
